export function composeExport(s0, s1) {
  return Object.assign(s0, s1)
}
function hasOwn(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key)
}

export function isString(target) {
  return Object.prototype.toString.call(target)
}

export function isVnode(node) {
  return node !== null && typeof node === 'object' && hasOwn(node, 'componentOptions')
}
